import {currency} from "../../../constants/constants";

export const options = [{ label: "UGX", value: "UGX" }]
export const getData = (key = "") => {
  let data = [
    {
      DayOfMonth: 1,
      Currency: currency,
      Noofbets: 36,
      TotalSales: 1249,
      Payouts: 1382.16,
      WinLoss: -133.16,
      WithholdingTax: 156.51,
      BettingTax: "0",
      Excise: 68.72,
    },
    {
      DayOfMonth: 2,
      Currency: "currency",
      Noofbets: 58,
      TotalSales: 2038,
      Payouts: 440.14,
      WinLoss: 1597.86,
      WithholdingTax: 14.32,
      BettingTax: 319.57,
      Excise: 104.93,
    },
    {
      DayOfMonth: 3,
      Currency: "currency",
      Noofbets: 56,
      TotalSales: 1090,
      Payouts: 735.81,
      WinLoss: 354.19,
      WithholdingTax: 1.95,
      BettingTax: 70.84,
      Excise: 12.6,
    },
    {
      DayOfMonth: 4,
      Currency: "currency",
      Noofbets: 27,
      TotalSales: 1006,
      Payouts: 912.45,
      WinLoss: 93.55,
      WithholdingTax: 61.03,
      BettingTax: 18.71,
      Excise: 37.44,
    },
    {
      DayOfMonth: 5,
      Currency: "currency",
      Noofbets: 147,
      TotalSales: 2632,
      Payouts: 1768.88,
      WinLoss: 863.12,
      WithholdingTax: 120.95,
      BettingTax: 172.62,
      Excise: 65.35,
    },
    {
      DayOfMonth: 6,
      Currency: "currency",
      Noofbets: 10,
      TotalSales: 197,
      Payouts: "0",
      WinLoss: 197,
      WithholdingTax: "0",
      BettingTax: 39.4,
      Excise: 13.76,
    },
    {
      DayOfMonth: 7,
      Currency: "currency",
      Noofbets: 12,
      TotalSales: 644,
      Payouts: 197.26,
      WinLoss: 446.74,
      WithholdingTax: 22.84,
      BettingTax: 89.35,
      Excise: 43.92,
    },
    {
      DayOfMonth: 8,
      Currency: "currency",
      Noofbets: 16,
      TotalSales: 780,
      Payouts: 275.53,
      WinLoss: 504.47,
      WithholdingTax: 21.39,
      BettingTax: 100.89,
      Excise: 54.46,
    },
    {
      DayOfMonth: 9,
      Currency: "currency",
      Noofbets: 67,
      TotalSales: 1743.1,
      Payouts: 1172.57,
      WinLoss: 570.53,
      WithholdingTax: 125.8,
      BettingTax: 114.11,
      Excise: 60.55,
    },
    {
      DayOfMonth: 10,
      Currency: "currency",
      Noofbets: 28,
      TotalSales: 1621.6,
      Payouts: 73.09,
      WinLoss: 1548.51,
      WithholdingTax: "0",
      BettingTax: 309.7,
      Excise: 103.6,
    },
    {
      DayOfMonth: 11,
      Currency: "currency",
      Noofbets: 23,
      TotalSales: 497,
      Payouts: 4342.04,
      WinLoss: -3845.04,
      WithholdingTax: 936.02,
      BettingTax: "0",
      Excise: 30.47,
    },
    {
      DayOfMonth: 12,
      Currency: "currency",
      Noofbets: 20,
      TotalSales: 1464,
      Payouts: 1707.84,
      WinLoss: -243.84,
      WithholdingTax: 401,
      BettingTax: "0",
      Excise: 98.7,
    },
    {
      DayOfMonth: 13,
      Currency: "currency",
      Noofbets: 15,
      TotalSales: 593,
      Payouts: 25.33,
      WinLoss: 567.67,
      WithholdingTax: 2.58,
      BettingTax: 113.53,
      Excise: 41.4,
    },
    {
      DayOfMonth: 14,
      Currency: "currency",
      Noofbets: 14,
      TotalSales: 985,
      Payouts: 25.33,
      WinLoss: 959.67,
      WithholdingTax: 2.58,
      BettingTax: 191.93,
      Excise: 68.4,
    },
    {
      DayOfMonth: 15,
      Currency: "currency",
      Noofbets: 16,
      TotalSales: 920,
      Payouts: 138.07,
      WinLoss: 781.93,
      WithholdingTax: 25.8,
      BettingTax: 156.39,
      Excise: 64.21,
    },
    {
      DayOfMonth: 16,
      Currency: "currency",
      Noofbets: 14,
      TotalSales: 458,
      Payouts: "0",
      WinLoss: 458,
      WithholdingTax: "0",
      BettingTax: 91.6,
      Excise: 31.97,
    },
    {
      DayOfMonth: 17,
      Currency: "currency",
      Noofbets: 27,
      TotalSales: 1210,
      Payouts: 571.86,
      WinLoss: 638.14,
      WithholdingTax: 25.67,
      BettingTax: 127.63,
      Excise: 78.69,
    },
    {
      DayOfMonth: 18,
      Currency: "currency",
      Noofbets: 39,
      TotalSales: 1541,
      Payouts: "0",
      WinLoss: 1541,
      WithholdingTax: "0",
      BettingTax: 308.2,
      Excise: 106.19,
    },
    {
      DayOfMonth: 19,
      Currency: "currency",
      Noofbets: 40,
      TotalSales: 1022,
      Payouts: 624.8,
      WinLoss: 397.2,
      WithholdingTax: 45.24,
      BettingTax: 79.44,
      Excise: 54.64,
    },
    {
      DayOfMonth: 20,
      Currency: "currency",
      Noofbets: 47,
      TotalSales: 1296,
      Payouts: 511.55,
      WinLoss: 784.45,
      WithholdingTax: 54.97,
      BettingTax: 156.89,
      Excise: 61.16,
    },
    {
      DayOfMonth: 21,
      Currency: "currency",
      Noofbets: 38,
      TotalSales: 1054,
      Payouts: 332.84,
      WinLoss: 721.16,
      WithholdingTax: 34.47,
      BettingTax: 144.23,
      Excise: 58.27,
    },
    {
      DayOfMonth: 22,
      Currency: "currency",
      Noofbets: 45,
      TotalSales: 1498,
      Payouts: 419.67,
      WinLoss: 1078.33,
      WithholdingTax: 76.15,
      BettingTax: 215.67,
      Excise: 100.46,
    },
    {
      DayOfMonth: 23,
      Currency: "currency",
      Noofbets: 80,
      TotalSales: 1031,
      Payouts: 372.03,
      WinLoss: 658.97,
      WithholdingTax: 61.04,
      BettingTax: 131.79,
      Excise: 69.71,
    },
    {
      DayOfMonth: 24,
      Currency: "currency",
      Noofbets: 24,
      TotalSales: 814,
      Payouts: 289.62,
      WinLoss: 524.38,
      WithholdingTax: "0",
      BettingTax: 104.88,
      Excise: 43.58,
    },
    {
      DayOfMonth: 25,
      Currency: "currency",
      Noofbets: 26,
      TotalSales: 1618,
      Payouts: "0",
      WinLoss: 1618,
      WithholdingTax: "0",
      BettingTax: 323.6,
      Excise: 85.7,
    },
    {
      DayOfMonth: 26,
      Currency: "currency",
      Noofbets: 7,
      TotalSales: 360,
      Payouts: 684.15,
      WinLoss: -324.15,
      WithholdingTax: 146.05,
      BettingTax: "0",
      Excise: 25.13,
    },
    {
      DayOfMonth: 27,
      Currency: "currency",
      Noofbets: 45,
      TotalSales: 916,
      Payouts: 893.3,
      WinLoss: 22.7,
      WithholdingTax: 25.58,
      BettingTax: 4.54,
      Excise: 24.43,
    },
    {
      DayOfMonth: 28,
      Currency: "currency",
      Noofbets: 23,
      TotalSales: 786,
      Payouts: 167.17,
      WinLoss: 618.83,
      WithholdingTax: "0",
      BettingTax: 123.77,
      Excise: 36.01,
    },
    {
      DayOfMonth: 29,
      Currency: "currency",
      Noofbets: 29,
      TotalSales: 2826,
      Payouts: 1233,
      WinLoss: 1593,
      WithholdingTax: 16.03,
      BettingTax: 318.6,
      Excise: 96.01,
    },
    {
      DayOfMonth: 30,
      Currency: "currency",
      Noofbets: 16,
      TotalSales: 361,
      Payouts: 1059.32,
      WinLoss: -698.32,
      WithholdingTax: 240.11,
      BettingTax: "0",
      Excise: 21.29,
    },
  ]

  return data
}
